import React, { useState, useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { MDBTooltip } from "mdb-react-ui-kit";
import { useSpecialFunctions } from "../../functions";
import Rights from "../../constants/Rights";

const OpenTicketsModal = ({
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  dateFromOpenTickets,
  setDateFromOpenTickets,
  dateToOpenTickets,
  setDateToOpenTickets,
  getOpenTicketsByPeriodOffTime,
  openTicketsByPeriodOffTime,
  setOpenTicketsByPeriodOffTime,
  callTicketVoidListFrom,
  scoreTickets,
  voidTickets,
  userRightsList,
}) => {
  const [ticketInfo, setTicketInfo] = useState([]);
  const closeButtonRef = useRef();
  const [raceIdSelected, setRaceIdSelected] = useState("");
  const { getTimeInfo, getDateInfo } = useSpecialFunctions();

  const hasSelectAllPermissions = () =>
    userRightsList.some((right) =>
      [Rights.FRM_VOID_TICKET, Rights.FRM_SCORE_TICKETS].includes(
        right.FormName,
      ),
    );

  useEffect(() => {
    if (
      callTicketVoidListFrom &&
      callTicketVoidListFrom.fromHeaderOpenTickets
    ) {
      getOpenTicketsByPeriodOffTime(true);
    }
  }, [callTicketVoidListFrom]);

  let headers,
    headersRacesTable,
    tableTicketsContent = [],
    tableRacesContent = [];

  useEffect(() => {
    if (openTicketsByPeriodOffTime.length > 0) {
      const updatedRace = openTicketsByPeriodOffTime.filter(
        (tickets) => tickets.RaceID === parseInt(raceIdSelected),
      )[0];

      if (
        updatedRace &&
        updatedRace.RaceTicketMainList &&
        updatedRace.RaceTicketMainList.length > 0
      ) {
        setTicketInfo({
          ...updatedRace,
          PastPostList: updatedRace.RaceTicketMainList,
        });
      } else {
        setTicketInfo([]);
      }
    }
  }, [openTicketsByPeriodOffTime, raceIdSelected]);

  const closeModal = () => {
    closeButtonRef.current.click();
    setDateFromOpenTickets(new Date());
    setDateToOpenTickets(new Date());
    setSelectedTicketsVoidScore([]);
    setRaceIdSelected("");
    setOpenTicketsByPeriodOffTime([]);
    setTicketInfo([]);
    setSelectAllTickets(false);
  };

  const viewTicketsInfo = (raceID, race) => {
    setRaceIdSelected(raceID);
    setTicketInfo(race, { RaceTicketMainList: race.RaceTicketMainList });

    setSelectedTicketsVoidScore([]);
  };

  headersRacesTable = (
    <tr className="text-center">
      <th hidden>IDRace</th>
      <th>Race</th>
      <th>Off Time</th>
    </tr>
  );

  // The main Race table
  if (openTicketsByPeriodOffTime) {
    tableRacesContent = openTicketsByPeriodOffTime.map((item, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={item.RaceID}
            style={{ cursor: "pointer" }}
            onClick={(e) =>
              viewTicketsInfo(
                item.RaceID,
                openTicketsByPeriodOffTime.filter(
                  (tickets) => tickets.RaceID === item.RaceID,
                )[0],
              )
            }
            className={raceIdSelected === item.RaceID ? "shadedRow" : ""}
          >
            <td key={"RaceID" + i} className="d-none">
              {item.RaceID}
            </td>
            {/* Race Name */}
            <td
              key={"RaceDescription" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.RaceDescription}
            </td>
            {/* Off Time */}
            <td
              key={"OffT" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.OffTime && getTimeInfo(item.OffTime)}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  headers = (
    <tr className="text-center">
      <th hidden>TicketID</th>
      <th style={{ width: "100px" }}>Placed</th>
      <th>Account</th>
      <th>Description</th>
      <th>Risk / Win</th>
    </tr>
  );

  const handleSelectAll = () => {
    const allTicketIDs = ticketInfo.RaceTicketMainList.map(
      (item) => item.TicketID,
    );

    if (selectAllTickets) {
      setSelectedTicketsVoidScore([]);
    } else {
      setSelectedTicketsVoidScore(allTicketIDs);
    }

    setSelectAllTickets(!selectAllTickets);
  };

  if (
    ticketInfo.length !== 0 &&
    ticketInfo.RaceTicketMainList &&
    ticketInfo.RaceTicketMainList.length !== 0
  ) {
    tableTicketsContent = ticketInfo.RaceTicketMainList.map((item, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={item.TicketID}
            style={{
              cursor: hasSelectAllPermissions() ? "pointer" : "inherit",
            }}
            onClick={() => ticketsChangeHandler(item.TicketID)}
            className={
              selectedTicketsVoidScore.includes(item.TicketID)
                ? "shadedRow"
                : ""
            }
          >
            <td key={"TicketID" + i} className="d-none">
              {item.TicketID}
            </td>
            {/* Placed */}
            <td
              key={"Placed" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {getDateInfo(item.PlacedDateTime)} <br />
              {getTimeInfo(item.PlacedDateTime)}
            </td>
            {/* Account */}
            <td
              key={"Account" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.AccountUserName}
            </td>

            {/* TicketDesc */}
            <td
              key={"TicketDesc" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.TicketDesc} {item.Selections}
            </td>
            {/* Risk/Win */}
            <td
              key={"TotalStake" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.TotalStake} / {item.WinPaid}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  const ticketsChangeHandler = (ticketID) => {
    if (!hasSelectAllPermissions()) {
      return;
    }
    if (selectedTicketsVoidScore.includes(ticketID)) {
      // If the id is already in the list, it deletes it.
      setSelectedTicketsVoidScore(
        selectedTicketsVoidScore.filter((item) => item !== ticketID),
      );
    } else {
      // If the id is not in the list, it adds it.
      setSelectedTicketsVoidScore([...selectedTicketsVoidScore, ticketID]);
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="openTicketsModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5 className="modal-title" id="openTicketsModal">
                Open Tickets
              </h5>
              <span
                data-dismiss="modal"
                ref={closeButtonRef}
                style={{ cursor: "inherit" }}
              ></span>
              <button type="button" className="close" onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div style={{ display: "flex" }}>
                <div>
                  <DatePicker
                    selected={dateFromOpenTickets}
                    onChange={(date) => {
                      setDateFromOpenTickets(date);
                    }}
                    className="form-control text-center"
                  />
                </div>
                <label
                  className="mr-2 ml-2 mt-1 lead"
                  style={{
                    color: "#8c8c8c",
                    fontSize: "16px",
                  }}
                >
                  To
                </label>
                <div>
                  <DatePicker
                    selected={dateToOpenTickets}
                    onChange={(date) => {
                      setDateToOpenTickets(date);
                    }}
                    className="form-control text-center"
                  />
                </div>
                <MDBTooltip
                  tag="i"
                  wrapperProps={{ href: "#" }}
                  title="Search"
                  placement="right"
                >
                  <button
                    type="button"
                    className="btn btn-info mb-3 ml-2"
                    onClick={() => {
                      setTicketInfo([]);
                      getOpenTicketsByPeriodOffTime();
                    }}
                    style={{
                      width: "31px",
                      borderRadius: "50px",
                      paddingRight: "8px",
                      paddingLeft: "7px",
                    }}
                  >
                    <i className="fas fa-search fa-bold"></i>
                  </button>
                </MDBTooltip>
              </div>
              <hr />
              <div className="row">
                <div className="col-sm-4">
                  <div
                    style={{
                      overflow: "auto",
                    }}
                    className="tablesPastPost"
                  >
                    <table
                      className="table table-hover table-sm"
                      style={{ marginTop: "21px" }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: "0",
                          background: "#d9d9d9",
                        }}
                      >
                        {headersRacesTable}
                      </thead>
                      <tbody className="table-lg">{tableRacesContent}</tbody>
                    </table>
                  </div>
                </div>
                <div className="col-sm-8">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="exampleCheck1"
                      checked={selectAllTickets}
                      onChange={handleSelectAll}
                      disabled={
                        !hasSelectAllPermissions() || ticketInfo?.length === 0
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="exampleCheck1"
                      style={{ color: "#8c8c8c", fontSize: "16px" }}
                    >
                      Select All Tickets
                    </label>
                  </div>
                  <div className="tablesPastPost">
                    <table className="table table-hover table-sm mt-1">
                      <thead
                        style={{
                          position: "sticky",
                          top: "0",
                          background: "#d9d9d9",
                        }}
                      >
                        {headers}
                      </thead>
                      <tbody className="table-lg">{tableTicketsContent}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-sm-6"></div>
              <div
                className="col-sm-6"
                style={{ textAlign: "right", paddingRight: "0px" }}
              >
                {userRightsList.find(
                  (right) => right.FormName === Rights.FRM_VOID_TICKET,
                ) && (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      voidTickets("OTHeader", selectedTicketsVoidScore)
                    }
                  >
                    Void Selected Tickets
                  </button>
                )}
                {userRightsList.find(
                  (right) => right.FormName === Rights.FRM_SCORE_TICKETS,
                ) && (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      scoreTickets("OTHeader", selectedTicketsVoidScore)
                    }
                    disabled={
                      !userRightsList.find(
                        (right) => right.FormName === Rights.FRM_SCORE_TICKETS,
                      )
                    }
                  >
                    Score Selected Tickets
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OpenTicketsModal;
